module.exports = __webpack_public_path__ + "img/Group4_english.80162f78.jpg";